import React, { useCallback, useMemo } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import Toast from 'react-native-root-toast';

import MarketSetupCreator from './MarketSetupCreator';
import { CREATE_MARKET_SETUP } from '../../../../common/graphql/marketSetup';
import { EmptyState, Screen } from '../../../design/components';

const MarketSetupCreatorView = () => {
	const navigation = useNavigation();
	const route = useRoute();
	const locationSetup = route.params?.locationSetup;

	const initialValues = useMemo(() => {
		if (!locationSetup) {
			return null;
		}
		return {
			locationSetup,
			assignees: [],
			placePhotos: [],
			place: null,
			machine: null,
			planogram: null,
			additionalInstructions: '',
		};
	}, [locationSetup]);

	const validation = useCallback(values => [
		{ field: 'placePhotos', error: 'Add at least one photo of the site', rule: values.placePhotos.length },
	], []);

	const handleSuccess = useCallback((newSetup) => {
		Toast.show('Market setup created');
		navigation.replace('MarketSetupDetailView', { marketSetupId: newSetup.id });
	}, [navigation]);

	if (!locationSetup || !initialValues) {
		return (
			<Screen>
				<EmptyState title="Unable to start market setup creator without a location setup." />
			</Screen>
		);
	}

	return (
		<MarketSetupCreator
			createMutation={CREATE_MARKET_SETUP}
			initialValues={initialValues}
			locationSetup={locationSetup}
			onSubmitSuccess={handleSuccess}
			validation={validation}
		/>
	);
};

export default MarketSetupCreatorView;
